export const BlobUtil = {
    downloadBlob(blob, filename) {
        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob);
            return;
        }

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(blob);
        var link = document.createElement("a");
        link.href = data;
        link.download = filename;
        link.click();
        setTimeout(function() {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
        }, 100);
    },
    openBlob(blob) {
        try {
            const popUp = window.open(window.URL.createObjectURL(blob));
            popUp.focus();
            return false;
        } catch (e) {
            return true;
        }
    }
};


